import styled, { DefaultThemeColors } from "styled-components";

export const IconContainer = styled.span<{ color?: DefaultThemeColors; }>`
  display: relative;
  color: ${(props) => props.theme.colors.main};
  margin-right: 4px;
`;
